import loggingService from './util/loggingService'
import axios from '@/plugins/axios'

var path = '/Lookup/'
var isDebug = false

const LookupEnum = {
    Unknown: 98,
    Other: 99
}

const YesNoUnknownEnum = {
    Yes: 1,
    No: 2,
    Unknown: 3,
    NotApplicable: 4
}

const YesNoUnknownList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Unknown' }
]

const YesNoUnknownNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Unknown' },
    { id: 4, description: 'N/A' }
]

const YesNoList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' }
]

const YesNoNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 4, description: 'N/A' }
]

const YesNoUndeterminedList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Undetermined' }
]

const YesNoUndeterminedNaList = [
    { id: 1, description: 'Yes' },
    { id: 2, description: 'No' },
    { id: 3, description: 'Undetermined' },
    { id: 4, description: 'N/A' }
]

const AboveUndergroundList = [
    { id: 1, description: 'Aboveground' },
    { id: 2, description: 'Underground' }
]

function listLookup (http, type) {
    loggingService.log(isDebug, 'Lookup service', `Fetching lookup: ${type}`)
    return http.get(path + type)
}

export default {
    LookupEnum: LookupEnum,
    YesNoUnknownEnum: YesNoUnknownEnum,
    YesNoUnknownList: YesNoUnknownList,
    YesNoUnknownNaList: YesNoUnknownNaList,
    YesNoNaList: YesNoNaList,
    YesNoList: YesNoList,
    YesNoUndeterminedList: YesNoUndeterminedList,
    YesNoUndeterminedNaList: YesNoUndeterminedNaList,
    AboveUndergroundList: AboveUndergroundList,
    listLookup: listLookup
}
